enum TransportResponsibleEnum {
  SELLER = "SELLER",
  BUYER = "BUYER",
  REVIVER = "REVIVER",
}

export default TransportResponsibleEnum;
